<div class="modal-dialog modal-lg" style="margin-top: 0px; margin-bottom: 0px">
  <div class="modal-content">
    <div class="modal-header">
      <aurora-icon-button class="close" type="button" (click)="close()" icon="times" size="large"></aurora-icon-button>
      <h4 class="modal-title">Validation Errors</h4>
    </div>

    <div class="modal-body">
      <ep-panel panelType="transparent">
        <ep-row>
          <div
            class="col-12"
            *ngFor="let object of evaluatedStateObjects$ | async"
            style="display: inline-block; max-width: 100%; margin-bottom: 5px"
          >
            <div class="col-12">
              <span style="font: var(--aurora-font-title-small); color: var(--aurora-semantic-foreground-neutral-primary)">{{
                getObjectDesc(object)
              }}</span>
              <!-- <span style="font-size: 10px;margin-left:5px; color:gray">[ID: {{ object.objectID }}]</span> -->
            </div>
            <div
              class="col-12"
              *ngFor="let error of getObjectErrors(object)"
              style="display: inline-block; max-width: 100%; margin-bottom: 0px"
            >
              <span>{{ error }}</span>
            </div>
          </div>
          <!-- {{ evaluatedStateObjects$ | async | json }} -->
        </ep-row>
      </ep-panel>
    </div>
    <div class="modal-footer">
      <aurora-button type="button" (click)="cancel()" variant="primary">Close</aurora-button>
    </div>
  </div>
</div>
